<template>
  <div class="container">

    <el-row>
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="formCase">
        <el-form-item label="经销店名称" prop="dealerName">
          <el-input disabled v-model="formCase.dealerName" v-if="formCase.type == 2"></el-input>
          <!-- <el-select v-model="formCase.dealerName" placeholder="请选择" v-if="formCase.type == 1">
            <el-option
              v-for="item in caseTypeOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="案件名称（零件名称-故障现象）" prop="title">
          <el-input v-model="formCase.title"></el-input>
        </el-form-item>
        <el-form-item label="新规/再发起" prop="caseType">
          <!--<el-select v-model="formCase.caseType" placeholder="请选择">
            <el-option
              v-for="item in caseTypeOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <el-radio v-model="formCase.caseType" v-for="item in caseTypeOption" :label="item" :value="item" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="VIN" prop="vin">
          <el-input v-model="formCase.vin" name="vin" placeholder="请输入VIN后九位">
            <el-button slot="append" icon="el-icon-search" @click.native="searchs"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="车型名称" prop="vehicleType">
          <el-input v-model="formCase.vehicleType"></el-input>
        </el-form-item>
        <el-form-item label="车型代码" prop="vehicleCode">
          <el-input v-model="formCase.vehicleCode"></el-input>
        </el-form-item>
        <el-form-item label="下线日期" prop="offlineDate">
          <el-date-picker
            v-model="formCase.offlineDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发动机型号" prop="engineModel">
          <el-input v-model="formCase.engineModel"></el-input>
        </el-form-item>
        <el-form-item label="入库时间" prop="doneDatetime">
          <el-date-picker
            v-model="formCase.doneDatetime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="行驶距离" prop="drivenDistance">
          <el-input type="number" v-model="formCase.drivenDistance"></el-input>
        </el-form-item>
        <el-form-item label="部位选择" prop="parts">
          <el-select v-model="formCase.parts[0]" placeholder="请选择">
            <el-option
              v-for="item in partIdsArr"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现象分类" prop="phenomenons">
          <el-select v-model="formCase.phenomenons[0]" placeholder="请选择">
            <el-option
              v-for="item in phenomenonIdsArr"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="DTC有无" prop="dtcint">
          <!--<el-select v-model="formCase.dtcInt" placeholder="请选择">
            <el-option
              v-for="item in dtcIntArr"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <el-radio v-model="formCase.dtcint" v-for="item in dtcIntArr" :label="item" :value="item" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="DTC" prop="dtc" v-if="formCase.dtcint == '有'">
          <el-input v-model="formCase.dtc"></el-input>
        </el-form-item>
        <el-form-item label="无DTC的原因" prop="noDtcReason" v-if="formCase.dtcint == '无'">
          <el-input v-model="formCase.noDtcReason"></el-input>
        </el-form-item>
        <el-form-item label="三包状态" prop="warrantyPeriod">
          <!-- <el-input v-model="formCase.warrantyPeriod"></el-input> -->
          <el-select v-model="formCase.warrantyPeriod" placeholder="请选择">
            <el-option v-for="(item, index) in warrantyPeriodOption" :key="index"  :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="kubun">
          <!--<el-select v-model="formCase.kubun" placeholder="请选择">
            <el-option
              v-for="item in kubunOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <el-radio v-model="formCase.kubun" v-for="item in kubunOption" :label="item" :value="item" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="子类型" prop="kubunExtra" v-if="formCase.kubun==='一般维修'">
          <!--<el-select v-model="formCase.kubun" placeholder="请选择">
            <el-option
              v-for="item in kubunOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <el-radio v-model="formCase.kubunExtra" v-for="item in kubunExtraOption" :label="item" :value="item" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="CR苦情" prop="complain" v-if="formCase.type == 1">
          <el-input v-model="formCase.complain"></el-input>
        </el-form-item>
        <el-form-item label="顾客描述" prop="customerConsultation" v-if="formCase.type == 2">
          <el-input type="textarea" v-model="formCase.customerConsultation"></el-input>
        </el-form-item>
        <el-form-item label="现象确认" prop="phenomenonConfirmation" v-if="formCase.type == 2">
          <el-input type="textarea" v-model="formCase.phenomenonConfirmation"></el-input>
        </el-form-item>
        <el-form-item label="检查内容" prop="inspectionDiagnosis" v-if="formCase.type == 2">
          <el-input type="textarea" v-model="formCase.inspectionDiagnosis"></el-input>
        </el-form-item>
        <el-form-item label="请求支援内容" prop="supportDiagnosis" v-if="formCase.type == 2">
          <el-input type="textarea" v-model="formCase.supportDiagnosis"></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <!-- <el-upload
            action="123"
            :before-upload="beforeUpload"
            :http-request="upload"
            list-type="picture-card"
            :file-list="fileList"
            :auto-upload="true"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog> -->
          <Upload url="api/file/Upload" :attac="formCase.attachmentIds" :fileList="fileList" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels()">取消</el-button>
          <el-button type="primary" :disabled="sub" @click.native="onSubmit">提交</el-button>
          <el-button type="success" :disabled="sub" @click.native="onSave">保存</el-button>
          <el-button type="danger" :disabled="sub" @click.native="onDelete">删除</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>

</template>

<script>
  import addCase, { getDefaultData, updateCase, submitCase, getImg, getVideo, searchVin, delete0 } from '@/api/case.js'
  import axios from '@/utils/api.request'
  import { Toast, MessageBox } from 'mint-ui'
  import Upload from './Upload'
  import Global from '@/config/global.js'

  export default {
    name: "addCase",
    components: { Upload },
    data() {
      return {
        formCase: {
          id: 0,
          title: '', //案件标题
          caseType: '', //案件类型
          vehicleType: '', //车型名称
          vehicleCode: '', //车型代码
          engineModel: '', //发动机型号
          warrantyPeriod: null, //三包状态
          kubun: '', //类型//GR/钣金/喷漆
          vin: '', //vin
          offlineDate: '', //下线日期
          doneDatetime: '', // 入库时间
          drivenDistance: '', //行驶里程
          phenomenons: [], //现象分类
          parts: [], //现象分类表示名称
          dtcint: null, //DTC有无
          dtc: null, //dtc
          complain: '', //CR苦情
          attachmentIds: [],
          dealerName: '', //DLR名
          type:0, //  type 1:tcmi 2:dealer
          customerConsultation: '', // 顾客问诊
          phenomenonConfirmation: '', // 现象确认
          inspectionDiagnosis: '', // 检查诊断
          supportDiagnosis: '', //请求支援内容
        },
        rules:{
          dealerName: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          title: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          caseType: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          vehicleType: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          vehicleCode: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          warrantyPeriod: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          kubun: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          kubunExtra: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          vin: [
            { required: true, message: '该项不能为空', trigger: 'change' },
            { min: 17, message: '该项至少输入17位' }
          ],
          offlineDate: [ 
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          drivenDistance: [
            { required: true, message: '该项不能为空', trigger: 'change' },
          ],
          phenomenons: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          parts: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          complain: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          dtcint: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          dtc: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          noDtcReason:  [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          engineModel: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          customerConsultation: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          phenomenonConfirmation: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          inspectionDiagnosis: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          supportDiagnosis: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          doneDatetime: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],

        },
        attachmentIdss: [],
        phenomenonIdsArr: [], //现象分类
        partIdsArr: [], //现象分类表示名称
        dtcIntArr: [], //DTC有无
        caseTypeOption: [],
        kubunOption: [],
        dialogImageUrl: '',
        dialogVisible: false,
        sub: false,
        user:[],
        fileList: [],
        warrantyPeriodOption:[],
        kubunExtraOption: ['一般', 'CR']
      }
    },
    created() {
        /*getImg().then(res=>{
            console.log(res)
        })*/
        this.user = JSON.parse(localStorage.getItem("user"))
        this.formCase.type = this.user.type
        this.formCase.dealerName = this.user.typeName
        var ids;
        if(this.$route.params && this.$route.params.id >0) {
          ids = this.$route.params.id
        }else {
          ids = 0
        }
        console.log(this.$route)
        getDefaultData(ids).then(res => {
          this.formCase.caseType = res.data.caseType
          this.phenomenonIdsArr = res.data.phenomenonOption
          this.partIdsArr = res.data.partOption
          this.dtcIntArr = res.data.dtcOption
          this.caseTypeOption = res.data.caseTypeOption
          this.kubunOption = res.data.kubunOption
          this.formCase.kubun = res.data.kubun
          this.warrantyPeriodOption = res.data.warrantyPeriodOption
          if(ids>0){
            this.formCase.id = res.data.id
            this.formCase.phenomenons = res.data.phenomenons
            this.formCase.parts = res.data.parts
            this.formCase.engineModel = res.data.engineModel
            this.formCase.dtc = res.data.dtc
            this.formCase.dtcint = res.data.dtcint
            this.formCase.complain = res.data.complain
            this.formCase.drivenDistance = res.data.drivenDistance
            this.formCase.offlineDate = res.data.offlineDate
            this.formCase.vin = res.data.vin
            this.formCase.kubun = res.data.kubun
            this.formCase.warrantyPeriod = res.data.warrantyPeriod
            this.formCase.vehicleCode = res.data.vehicleCode
            this.formCase.vehicleType = res.data.vehicleType
            this.formCase.title = res.data.title
            this.formCase.customerConsultation = res.data.customerConsultation
            this.formCase.phenomenonConfirmation = res.data.phenomenonConfirmation
            this.formCase.inspectionDiagnosis = res.data.inspectionDiagnosis
            this.formCase.supportDiagnosis = res.data.supportDiagnosis
            this.formCase.doneDatetime = res.data.doneDatetime
            this.kubunExtraOption = res.data.kubunExtraOption
            if(this.formCase.vin&&!this.formCase.offlineDate&&!this.formCase.vehicleType&&!this.formCase.vehicleCode){
              this.searchs()
            }
            if(res.data.attachments){
              res.data.attachments.forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime
                }
                this.fileList.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){

                   this.fileList[i].url = Global.server_api + v.url;
                  // getVideo(v.url).then(resp=>{
                  //   this.fileList[i].url = URL.createObjectURL(resp.data)

                  // })
                }

              })
            }

          }else if(this.$route.query.title && !this.$route.query.id){
            this.formCase = this.$route.query
            this.formCase.type = this.user.type
            this.formCase.dealerName = this.user.typeName
            console.log(this.formCase.attachmentIds)
            if(this.formCase.attachments){
              this.formCase.attachments.forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime
                }
                this.fileList.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){

                   this.fileList[i].url = Global.server_api + v.url;

                  // getVideo(v.url).then(resp=>{
                  //   this.fileList[i].url = URL.createObjectURL(resp.data)

                  // })
                }

              })
            }
          }
        });

    },
    methods: {
      subs(data) {
        this.sub = data
      },
      cancels(){
         this.$router.go(-1);
      },
      onDelete() {
        delete0(this.formCase.id).then(res => {
          Toast({
            message: '删除成功',
            position: 'top',
          });
          this.$router.push('/case')
        })
      },
      searchs(){
        if(this.formCase.vin.length<9){
          Toast({
            message: '请填入VIN后9位搜索',
            position: 'top',
          });
        }else{
          searchVin(this.formCase.vin).then(res => {
            if(res.data.success && res.data.data.lineOffAct){
              this.formCase.vin = res.data.data.vin
              this.formCase.offlineDate = res.data.data.lineOffAct
              this.formCase.vehicleType = res.data.data.vehicleName
              this.formCase.vehicleCode = res.data.data.model
              Toast({
                message: res.data.msg,
                position: 'top',
              });
            }else{
              if(res.data.data&&!res.data.data.lineOffAct){
                Toast({
                  message: '请输入正确的vin',
                  position: 'top',
                });
                this.formCase.offlineDate = ''
                this.formCase.vehicleType = ''
                this.formCase.vehicleCode = ''
              }else {
                Toast({
                  message: res.data.msg,
                  position: 'top',
                });
                this.formCase.offlineDate = ''
                this.formCase.vehicleType = ''
                this.formCase.vehicleCode = ''
              }
              
            }
            
          })
        }
      },
      beforeUpload() {
          this.sub = true;
      },
      upload(fileObj) {
        const formData = new FormData()
        formData.append('file', fileObj.file)
        return axios.request({
          url: 'api/file/Upload',
          method: 'post',
          data: formData,
          onUploadProgress: progressEvent => {
            const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
            fileObj.onProgress({ percent: complete })
          },
        }).then(this.handleUpload, this.handleUploadError)
        /*let fd = new FormData()
         fd.append('file', file.file)
         uploadFile(fd, file).then(response => {
         console.log(response.data);
         console.log(this.formCasedetail.attachmentIds)
         console.log(file);
         file.data.list.push({
         name:response.data.data.name,
         status:"success",
         uid:new Date().getTime(),
         url:response.data.data.url
         })
         }).catch(err => {
         console.log(err);
         })*/
      },
      handleRemove(file, fileList) {
        this.attachmentIdss.forEach((v, i) => {
            if(v.name == file.name){
                this.attachmentIdss = this.attachmentIdss.slice(i+1)
            }
        })
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleUpload(res) {
        this.attachmentIdss.push({id : res.data.data.id, name : res.data.data.rawName})
        this.sub = false
      },
      onSave(){
        this.$on('changeAttachs',data => {
          console.log(data)
          this.attachmentIdss = data
        })
        this.formCase.attachmentIds = []
        this.attachmentIdss.forEach((v, i) => {
          this.formCase.attachmentIds.push(v.id)
        })
        if(this.formCase.id>0){
          updateCase(this.formCase.id, this.formCase).then(res => {
              if(res.data.success){
                Toast({
                  message: res.data.msg,
                  iconClass: 'icon el-icon-check'
                });
                this.$router.push('/case')
              }else{
                Toast({
                  message: res.data.msg,
                  iconClass: 'icon el-icon-close'
                });
              }
          })
        }else{
          addCase(this.formCase).then(res => {
              console.log(res)
            if(res.data.success){
              this.formCase.id = res.data.data.id
              Toast({
                message: res.data.msg,
                iconClass: 'icon el-icon-check',
                duration: 2000
              });
              setTimeout( () =>{
                this.$router.push('/case')
              },2000)
            }else{
              Toast({
                message: res.msg,
                iconClass: 'icon el-icon-close'
              });
            }
          })
        }
        this.sub = true
        setTimeout(() => {
            this.sub = false
        }, 3000)

      },
      changeAttachs(data) {
          console.log(data)
        this.attachmentIdss = data;
      },
      onSubmit(){
        this.$on('changeAttachs',data => {
          console.log(data)
          this.attachmentIdss = data
        })
        //this.changeAttachs()
        this.$refs.ruleForm.validate((valid) => {
          if(valid){
            MessageBox.confirm('',{
              title: '提示',
              message: '提交后无法撤回，确认提交?',
              showCancelButton: true
            }).then(() => {

              this.formCase.attachmentIds = []
              if(this.attachmentIdss){
                this.attachmentIdss.forEach((v, i) => {
                  this.formCase.attachmentIds.push(v.id)
                })
              }
              submitCase(this.formCase).then((res)=>{
                if(res.data.success){
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-check'
                  });
                  this.$router.push('/case')
                }else{
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-close'
                  });
                }
              })
              this.sub = true
              setTimeout(() => {
                this.sub = false
              }, 3000)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });
            });
          }
        })
      }
    },
    mounted(){
      this.attachmentIdss = this.fileList
    }
  }
</script>

<style scoped>
  .container {
    max-width: 500px;
    margin: auto;
    padding: 0 0.32rem;
    background: #fff;
  }
  .el-col, .el-col-18 {
    height:0.3rem;
    line-height: 0.4rem;
  }
  .el-col {
    padding: 0 0.1rem;
  }
  .header {
    padding-bottom: 0.15rem;
    border-bottom: 1px solid blue;
  }
  .el-form-item {
    text-align: left;
    margin: 0.1rem 0;
  }
  .el-form-item__label,.el-form-item__content {
    line-height: 0.4rem;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input__icon {
    height: auto;
  }
  .el-row {
    margin-bottom: 0.1rem;
  }
  .el-radio{
    margin-right: 3%;
    margin-bottom: 15px;
  }
</style>
